import {
  lightGrey,
  skyBlue,
  sunflowerYellow,
  peacockBlue,
  waterBlue,
} from '@g4/boneyard/lib/theme/colors';
import {
  white,
  blue100,
  blue500,
  blue700,
  blue900,
  lightBlue900,
  greyA100,
  grey50,
  grey100,
  grey500,
  grey900,
  yellow100,
  yellow800,
  green50,
  orange500,
  red500,
  yellow200,
} from './colors';

const colors = {
  alertRed: red500,
  light: white,
  primary: blue900,
  secondary: blue100,
  secondaryStroke: blue500,
  alternate: blue500,
  alternateText: lightBlue900,
  disabled: grey100,
  disabledText: grey500,
  shadow: greyA100,
  border: grey50,
  warning: yellow100,
  notification: yellow100,
  selection: green50,
  focus: blue100,
  link: '#1871ca',
  linkActive: '#13589c',
  linkLight: grey50,
  linkLightActive: white,
  peacockBlue: peacockBlue,
  formPlaceholder: '#716f6f',
  text: peacockBlue,
  textSecondary: grey900,
  waterBlue: waterBlue,
  popupHeaderBackground: blue700,
  lightYellow: yellow200,
  form: {
    required: red500,
    focused: skyBlue,
    outline: lightGrey,
    stroke: grey100,
    radio: {
      checked: peacockBlue,
      background: white,
      stroke: lightGrey,
    },
    checkbox: {
      active: peacockBlue,
      background: white,
      stroke: lightGrey,
    },
  },
  tabs: {
    border: yellow800,
    text: lightBlue900,
    active: {
      border: orange500,
      text: grey900,
    },
  },
  podImg: {
    ribbonBackground: sunflowerYellow,
    ribbonText: peacockBlue,
    placeholder: lightGrey,
  },
  bogoPaymentDisclaimer: {
    alwaysCardRequiredBg: yellow100,
    disclaimerTextBg: '#E9F2F9',
  },
};

export default colors;
